function GenericErrorHandler(response = {}) {
  const { data = {}, status } = response;
  const { error = {} } = data;
  const { httpCode: statusCode = "no-code", message = "", errorCode } = error;

  if (statusCode === 422 && (errorCode === "INVALID_TOKEN"|| errorCode === "RMS002_INVALID_TOKEN")) {
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "troca-email-token-invalido",
          title: "Código inválido",
          message: `Verifique se o código informado está correto e tente novamente.`,
        },
      },
    };
  } if (status === 401) {
    return {
      ...data,
      code: status,
      error: {
        errorCode,
        warning: {
          id: "sessao-expirada",
          title: "Sessão expirada",
          message: "efetue o login novamente",
        },
      },
    };
  } else if (status === 500) {
    return {
      ...data,
      code: status,
      error: {
        errorCode,
        warning: {
          id: "ERRO-500",
          title: "Ops",
          message: `Ocorreu um erro inesperado! Por favor, tente novamente mais tarde.`,
          originalMessage: message,
          systemError: data,
        },
      },
    };
  } else {
    return {
      ...data,
      code: status,
      error: {
        errorCode,
        warning: {
          id: "ERRO",
          title: "Ocorreu um erro inesperado!",
          message: "Verifique sua conexão com a internet e tente novamente",
          systemError: data,
        },
      },
    };
  }
}
export default GenericErrorHandler;
